import { lazy, Suspense, useEffect } from "react";
import { SiteFooter } from "../SiteFooter.jsx";
import { BrandLockup } from "../landing/BrandLockup.jsx";

const legalContents = {
  privacy: lazy(() => import("./PrivacyPolicy.jsx")),
  termini: lazy(() => import("./TermsOfUse.jsx")),
  "ai-disclosure": lazy(() => import("./AiDisclosure.jsx")),
  cookie: lazy(() => import("./CookiePolicy.jsx")),
  "note-legali": lazy(() => import("./LegalNotice.jsx")),
  contatti: lazy(() => import("./ContactPage.jsx")),
};

function updateMetaDescription(description) {
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", description);
}

export function LegalDocument({ page }) {
  const Content = legalContents[page.slug];

  useEffect(() => {
    document.title = `${page.title} | Il Consulente AI`;
    updateMetaDescription(page.description);
  }, [page.description, page.title]);

  return (
    <div className="legal-shell">
      <header className="legal-header">
        <a href="/" aria-label="Il Consulente AI, torna alla pagina iniziale">
          <BrandLockup compact />
        </a>
        <a className="legal-back" href="/">Torna al percorso</a>
      </header>
      <main className="legal-main" id="main">
        <div className="legal-hero">
          <p>Informazioni del servizio</p>
          <h1>{page.title}</h1>
          <span>{page.description}</span>
          {page.showVersion !== false ? <small>Versione aggiornata al 10 agosto 2026</small> : null}
        </div>
        <Suspense fallback={<p className="legal-loading">Apro il documento…</p>}>
          <Content />
        </Suspense>
      </main>
      <SiteFooter legal />
    </div>
  );
}
